@if (question) { @if (question.isCountingDown &&
!question.model.is_poll_question) {
<qa-countdown> </qa-countdown>
} @if (question.model.is_poll_question) {
<qa-poll-announcement> </qa-poll-announcement>
} @if (!question.isCountingDown) {
<div class="inner">
  <div class="left flex-column">
    <ng-scrollbar #questionWrapper data-check="true" class="text">
      @if (question.model.is_poll_question) {
      <div class="visualization-selector">
        <mat-button-toggle-group
          [value]="selectedVisualization"
          (change)="selectVisualization($event.value)"
        >
          @if (question.model.type === questionType.FreeText) {
          <mat-button-toggle value="cloud"
            ><mat-icon>abc</mat-icon></mat-button-toggle
          >
          }
          <mat-button-toggle value="list"
            ><mat-icon>view_list</mat-icon></mat-button-toggle
          >
          <mat-button-toggle value="donut"
            ><mat-icon>donut_large</mat-icon></mat-button-toggle
          >
          @if (question.model.type === questionType.FreeText) {
          <mat-button-toggle value="card"
            ><mat-icon>space_dashboard</mat-icon></mat-button-toggle
          >
          }
        </mat-button-toggle-group>
      </div>
      } @if (question?.model?.media?.uuid) {
      <qa-image-display [model]="question.model"></qa-image-display>
      }
      <qa-markdown-katex [data]="question.model.text"> </qa-markdown-katex>
      <div class="answers" [class.poll]="question.model.is_poll_question">
        @if (!question.model.is_poll_question) {
        <qa-question-answers
          [disabled]="
            answersDisabled ||
            question.isAnswered ||
            question.isCompleted ||
            question.isDisabled
          "
          [control]="answerSelectionControl"
          [question]="question.model"
          [showCorrectAnswers]="question.isCompleted"
          [trueFalseOrderInverted]="question.trueFalseOrderInverted"
        >
        </qa-question-answers>
        } @else { @if ( question.model.type === questionType.FreeText &&
        selectedVisualization === 'cloud') {
        <qa-word-cloud-visualization
          [words]="mapToStrings(displayedAnswerStats)"
        ></qa-word-cloud-visualization>
        } @else { @if ( selectedVisualization === 'card' && question.model.type
        === questionType.FreeText) {
        <qa-free-text-answers-grid
          [answers]="questionAnswers"
        ></qa-free-text-answers-grid>
        } @else { @if ( !question.model.is_poll_question ||
        selectedVisualization === 'list') { @for (answerStat of
        displayedAnswerStats; track $index) {
        <div class="answer">
          <div class="answer-text">
            <div class="top">
              <qa-markdown-katex [data]="answerStat.answer.text" class="text">
              </qa-markdown-katex>
              <div class="amount">
                {{ answerStat.answers_total }}
              </div>
            </div>
            <div class="bar">
              <div
                [style.width]="getAnswerBarWidth(answerStat.answers_total)"
                class="piece"
              ></div>
            </div>
          </div>
        </div>
        } } @else {
        <qa-donut-chart
          [sections]="answerSections"
          [sort]="true"
          [large]="true"
        >
        </qa-donut-chart>
        } } } } @if (!answersDisabled) { @if (!question.isAnswered &&
        !question.isCompleted) {
        <button
          (click)="submitAnswer()"
          [disabled]="isSubmitAnswerDisabled"
          class="submit-answer-button"
          color="primary"
          mat-button
          type="button"
          data-cy="logInAnswer"
        >
          <mat-icon> done </mat-icon>
          {{ 'question.label.submitAns' | translate }}
        </button>
        } @if ( !isAnswerRetractionDisabled && question.isAnswered &&
        !question.isCompleted ) {
        <button
          (click)="retractAnswer()"
          class="retract-answer-button"
          color="primary"
          mat-button
          type="button"
        >
          <mat-icon> edit </mat-icon>
          {{ 'question.label.editAns' | translate }}
        </button>
        } }
      </div>
    </ng-scrollbar>
  </div>
  <div class="right">
    <ng-scrollbar>
      <div
        class="play-timer-container"
        [class.poll-question]="question.model.is_poll_question"
      >
        <qa-play-timer [showLargeTimer]="true"></qa-play-timer>
        <qa-play-timer class="small-mobile-only"></qa-play-timer>
      </div>
      <div class="submitted-answers">
        <div class="progress">
          <div class="top">
            <div class="position">
              <span class="submitted">{{
                answerSubmitted | number : '1.0-0'
              }}</span>
              <span class="divider">/</span
              ><span class="total">{{ numOfUsers | number : '1.0-0' }}</span>
            </div>
            <div class="label">
              {{ 'question.label.answersSubmitted' | translate }}
            </div>
          </div>
          <mat-progress-bar
            [value]="getProgressAnswer(answerSubmitted, numOfUsers)"
            color="primary"
          >
          </mat-progress-bar>
        </div>
      </div>
    </ng-scrollbar>
    <div class="action-button">
      <qa-button
        [isRaisedButton]="true"
        [label]="
          !question.model.is_poll_question
            ? ('liveEvents.label.jumpToEval' | translate)
            : ('liveEvents.label.endPoll' | translate)
        "
        icon="arrow_forward"
        (submitted)="endQuestion()"
      ></qa-button>
    </div>
  </div>
</div>
}
<div [matRippleDisabled]="true" #submitAnswerRipple matRipple></div>
}
